import { useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { ICalculation } from "../../../models/calculation";
import { VerticesLimitsDisplay } from "../VerticesLimitsDisplay";

interface IProps {
    calculation: ICalculation;
}

export const CalcPropsVerticesLimits = ({ calculation }: IProps) => {
    const [open, setOpen] = useState(false);

    return (
        <Accordion>
            <Accordion.Title active={open} index={0} onClick={() => setOpen(!open)}>
                <Icon name="dropdown" />
                Vertices Limits
            </Accordion.Title>
            <Accordion.Content active={open}>
                <VerticesLimitsDisplay calculation={calculation} />
            </Accordion.Content>
        </Accordion>
    );
};
